
import ReactPaginate from "react-paginate";

const PreIcon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" >
<path strokeLinecap="round" strokeLinejoin="round" d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5" />
</svg>


const NextIcon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" >
    <path strokeLinecap="round" strokeLinejoin="round" d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5" />
</svg>


const ReactPaginationStyle = ({ total, currentPage, handlePagination, limit }) => {
    const count = Number(Math.ceil(total / limit));
    return (
        <ReactPaginate
            previousLabel={<span className="border border-secondary text-secondary rounded-md w-6 h-6 flex justify-center items-center">{PreIcon}</span>}
            nextLabel={<span className="border border-secondary text-secondary rounded-md w-6 h-6 flex justify-center items-center">{NextIcon}</span>}
            pageCount={count || 1}
            breakLabel='...'
            pageRangeDisplayed={1}
            activeLinkClassName="bg-primary text-white rounded-md flex justify-center items-center min-h-8 min-w-8 px-2 tabular-nums font-medium"
            pageClassName="flex justify-center text-secondary items-center rounded-md border border-secondary min-h-8 min-w-8 shrink-0 px-1.5"
            pageLinkClassName="flex h-full min-h-8 w-full items-center justify-center tabular-nums outline-none rounded-[inherit]"
            breakClassName="flex items-center justify-center shrink-0 min-h-8 px-1 text-secondary select-none"
            breakLinkClassName="inline-flex items-center justify-center px-1 min-w-8"
            marginPagesDisplayed={2}
            previousClassName="shrink-0"
            nextClassName="shrink-0"
            forcePage={currentPage !== 0 ? currentPage - 1 : 0}
            onPageChange={(page) => handlePagination(page)}
            containerClassName="pagination react-paginate flex flex-wrap justify-end gap-2 my-2 text-sm"
        />
    )
}

export default ReactPaginationStyle;